module.exports = __webpack_public_path__ + "img/policy-dots.2f09fcf.svg";